<template>
  <div class="desc">
    <AppDescriptionItem
      v-for="(option, index) of options"
      :key="index"
      :icon="option.icon"
      :label="option.label"
      :value="option.value"
      :showAdditional="option.showAdditional"
      :showAdditionalText="option.showAdditionalText"
      @more="onMore(option.id)"
    />

    <AppModal
      ref="schedule"
      class="schedule"
    >
      <p class="schedule__title h3">График работы</p>

      <div class="schedule__row"
        v-for="(item, index) of schedule"
        :key="index"
      >
        <div class="schedule__key">{{ item.weekDay }}</div>
        <div class="schedule__value">{{ item.time }}</div>
      </div>
    </AppModal>
    <BaseButton
      theme="simple"
      class="information__btn-delete"
      @click="onDelete"
    >
      Удалить
    </BaseButton>
  </div>
</template>

<script>
import AppDescriptionItem from './AppDescriptionItem'
import AppModal from '@/components/AppModal'
import BaseButton from '@/components/Base/BaseButton'

export default {
  name: 'AppDescription',
  components: {
    AppModal,
    AppDescriptionItem,
    BaseButton
  },
  props: {
    address: {
      type: [String, Number],
      default: null
    },
    price: {
      type: [String, Number],
      default: null
    },
    rating: {
      type: [String, Number],
      default: null
    },
    telephone: {
      type: [String, Number],
      default: null
    },
    coating: {
      type: [String, Number],
      default: null
    },
    fieldSize: {
      type: [String, Number],
      default: null
    },
    balls: {
      type: [String, Number],
      default: null
    },
    showers: {
      type: [String, Number],
      default: null
    },
    changingRooms: {
      type: [String, Number],
      default: null
    },
    manishki: {
      type: [String, Number],
      default: null
    },
    lighting: {
      type: [String, Number],
      default: null
    },
    studdedCleats: {
      type: [String, Number],
      default: null
    },
    paymentTransfer: {
      type: [String, Number],
      default: null
    },
    current: {
      type: [String, Number],
      default: null
    },
    schedule: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    options () {
      return [
        {
          id: 'address',
          icon: 'pin',
          label: this.address,
          value: null
        },
        {
          id: 'schedule',
          icon: 'clock',
          label: 'График работы',
          value: this.current,
          showAdditional: true,
          showAdditionalText: 'Показать весь'
        },
        {
          id: 'price',
          icon: 'dollar',
          label: 'Стоимость',
          value: this.price
        },
        {
          id: 'rating',
          icon: 'chat',
          label: 'Рейтинг',
          value: this.rating
        },
        {
          id: 'phone',
          icon: 'call',
          label: 'Телефон',
          value: this.telephone
        },
        {
          id: 'coating',
          icon: 'coating',
          label: 'Покрытие',
          value: this.coating
        },
        {
          id: 'fieldSize',
          icon: 'field',
          label: 'Размер поля',
          value: this.fieldSize
        },
        {
          id: 'ball',
          icon: 'ball',
          label: 'Мячи',
          value: this.balls
        },
        {
          id: 'showers',
          icon: 'showers',
          label: 'Душевые',
          value: this.showers
        },
        {
          id: 'changingRooms',
          icon: 'door',
          label: 'Раздевалки',
          value: this.changingRooms
        },
        {
          id: 'tshirt',
          icon: 'tshirt',
          label: 'Манишки',
          value: this.manishki
        },
        {
          id: 'lamp',
          icon: 'lamp',
          label: 'Освещение',
          value: this.lighting
        },
        {
          id: 'boot',
          icon: 'boot',
          label: 'Шипованные бутсы',
          value: this.studdedCleats
        },
        {
          id: 'pay-card',
          icon: 'pay-card',
          label: 'Оплата переводом',
          value: this.paymentTransfer
        }
      ]
    }
  },
  methods: {
    onMore (id) {
      if (id === 'schedule') {
        this.$refs.schedule.open()
      }
    },
    async onDelete () {
      if (!confirm('Вы уверены?')) { return }
      const id = this.$route.params.id

      try {
        await this.$api.playground.delete(id)
        this.$router.push('/')
      } catch (e) {
        console.log(e)
      }
    }

  }
}
</script>

<style lang="scss" scoped>

.information {
  &__btn-delete {
    padding: 0;
    color: red;
    margin-top: 20px;
  }
}
.schedule {
  &__title {
    margin-bottom: 18px;
  }

  &__row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 21px;
    color: #AEAEAE;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
  &__key {
    width: 50%;
    flex-shrink: 0;
  }
  &__value {
    width: 50%;
    flex-shrink: 0;
    text-align: right;
  }
}
</style>
